var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card", attrs: { "data-tab-clarifications": "" } },
    [
      _vm.page && _vm.pageSize
        ? _c("h5", { staticClass: "card-header" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.ui.formatString(_vm.T.clarificationsRangeHeader, {
                    lowCount: (_vm.page - 1) * _vm.pageSize + 1,
                    highCount: _vm.page * _vm.pageSize
                  })
                ) +
                " "
            )
          ])
        : _c("h5", { staticClass: "card-header" }, [
            _vm._v(_vm._s(_vm.T.wordsClarifications))
          ]),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _vm._t("new-clarification", [
            _vm.problems.length
              ? _c(
                  "div",
                  { staticClass: "mb-3" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-primary",
                        attrs: {
                          href: "#clarifications/all/new",
                          "data-new-clarification-button": ""
                        },
                        on: {
                          click: function($event) {
                            _vm.currentPopupDisplayed =
                              _vm.PopupDisplayed.NewClarification
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.T.wordsNewClarification) + " ")]
                    ),
                    _c("omegaup-overlay", {
                      attrs: {
                        "show-overlay":
                          _vm.currentPopupDisplayed !== _vm.PopupDisplayed.None
                      },
                      on: { "hide-overlay": _vm.onPopupDismissed },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "popup",
                            fn: function() {
                              return [
                                _c("omegaup-arena-new-clarification-popup", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.currentPopupDisplayed ===
                                        _vm.PopupDisplayed.NewClarification,
                                      expression:
                                        "\n                currentPopupDisplayed === PopupDisplayed.NewClarification\n              "
                                    }
                                  ],
                                  attrs: {
                                    problems: _vm.problems,
                                    users: _vm.users,
                                    "problem-alias": _vm.problemAlias,
                                    username: _vm.username
                                  },
                                  on: {
                                    "new-clarification": function(
                                      contestClarification
                                    ) {
                                      return _vm.$emit(
                                        "new-clarification",
                                        contestClarification
                                      )
                                    },
                                    dismiss: _vm.onPopupDismissed
                                  }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        620433408
                      )
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _c("div", { staticClass: "form-inline" }, [
            _vm.allowFilterByAssignment
              ? _c("label", [
                  _vm._v(" " + _vm._s(_vm.T.wordsFilterByHomework) + " "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedAssignment,
                          expression: "selectedAssignment"
                        }
                      ],
                      staticClass: "form-control custom-select ml-1",
                      attrs: { name: "problem" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedAssignment = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(_vm.assignmentsNames, function(assignmentName) {
                      return _c(
                        "option",
                        {
                          key: assignmentName,
                          domProps: { value: assignmentName }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(assignmentName ? assignmentName : "") +
                              " "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e(),
            _c("label", { class: { "ml-md-4": _vm.allowFilterByAssignment } }, [
              _vm._v(" " + _vm._s(_vm.T.wordsFilterByProblem) + " "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedProblem,
                      expression: "selectedProblem"
                    }
                  ],
                  staticClass: "form-control custom-select ml-1",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selectedProblem = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                _vm._l(_vm.problemsNames, function(problemName) {
                  return _c(
                    "option",
                    { key: problemName, domProps: { value: problemName } },
                    [_vm._v(" " + _vm._s(problemName) + " ")]
                  )
                }),
                0
              )
            ])
          ])
        ],
        2
      ),
      _c("div", { staticClass: "table-responsive" }, [
        _c("table", { staticClass: "table mb-0" }, [
          _c("thead", [
            _c("tr", { staticClass: "text-nowrap" }, [
              _c(
                "th",
                { staticClass: "text-center", attrs: { scope: "col" } },
                [_vm._v(_vm._s(_vm.T.clarificationInfo))]
              ),
              _c(
                "th",
                { staticClass: "text-center", attrs: { scope: "col" } },
                [_vm._v(_vm._s(_vm.T.wordsMessage))]
              ),
              _c(
                "th",
                { staticClass: "text-center", attrs: { scope: "col" } },
                [_vm._v(_vm._s(_vm.T.wordsResult))]
              )
            ])
          ]),
          _c(
            "tbody",
            _vm._l(_vm.filteredClarifications, function(clarification) {
              return _c("omegaup-clarification", {
                key: clarification.clarification_id,
                attrs: {
                  "is-admin": _vm.isAdmin,
                  selected: _vm.clarificationSelected(
                    clarification.clarification_id
                  ),
                  clarification: clarification
                },
                on: {
                  "clarification-response": function(response) {
                    return _vm.$emit(
                      "clarification-response",
                      Object.assign({}, response, {
                        message: clarification.message
                      })
                    )
                  }
                }
              })
            }),
            1
          )
        ])
      ]),
      _vm.filteredClarifications.length === 0
        ? _c("div", { staticClass: "empty-table-message py-2" }, [
            _vm._v(" " + _vm._s(_vm.T.clarificationsEmpty) + " ")
          ])
        : _vm._e(),
      _vm.pagerItems
        ? _c(
            "div",
            { staticClass: "card-footer" },
            [
              _c("omegaup-common-paginator", {
                attrs: { "pager-items": _vm.pagerItems }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }